<template lang="pug">
#denuncia-inserir-exportar
    BaseHeader(
        :titulo='translate("title")',
        :voltarPara='!stateShared.exportando || "emit"',
        @voltarClicado='irListaDenuncia'
    )
    .denuncia-inserir
        DenunciaCamposInserir(v-show='!stateShared.exportando')
        DenunciaTabelaInserirDados
        DenunciaResultado(v-if='!!stateShared.resultado')
        .denuncia-inserir__footer(
            v-if='!!stateShared.resultado',
            v-show='!stateShared.exportando'
        )
            button.denuncia-inserir__button.denuncia-inserir__button--secondary(
                @click='irListaDenuncia'
            )
                span {{ i18n.t('denuncia.view.buttons.retornar') }}
            //- button.denuncia-inserir__button(@click='exportElement')
            //-     span {{ i18n.t('denuncia.view.buttons.export') }}
</template>
<script>
import { defineComponent, getCurrentInstance, onUnmounted } from 'vue';
import useShareReport from '@/modules/denuncia/composition/useShareReport';
import useShareReportInsert from '@/modules/denuncia/composition/useShareReportInsert';
import i18n from '@/main';

export default defineComponent({
    components: {
        BaseHeader: () => import('@/components/BaseHeader.vue'),
        DenunciaCamposInserir: () =>
            import(
                '@/modules/denuncia/views/components/DenunciaCamposInserir.vue'
            ),
        DenunciaTabelaInserirDados: () =>
            import(
                '@/modules/denuncia/views/components/DenunciaTabelaInserirDados.vue'
            ),
        DenunciaResultado: () =>
            import('@/modules/denuncia/views/components/DenunciaResultado.vue')
    },
    setup() {
        const { exportResults, ...shared } = useShareReport();
        const { translate, clear, state } = useShareReportInsert();
        const vm = getCurrentInstance().proxy;

        function irListaDenuncia() {
            shared.clear();
            clear();
            vm.$router.push({
                name: 'denuncias'
            });

            state.resultado = null;
            state.quantidadeResultados = 0;
        }
        function exportElement() {
            const element = document.getElementById(
                'denuncia-inserir-exportar'
            );

            exportResults(element);
        }

        onUnmounted(() => {
            clear();
            shared.clear();
        });

        return {
            stateShared: shared.state,
            i18n,
            translate,
            irListaDenuncia,
            exportResults,
            clear,
            exportElement
        };
    }
});
</script>

<style lang="scss">
.denuncia-inserir {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    &__titulo {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        color: var(--primary);
    }

    &__button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        background-color: var(--primary);
        color: $white;
        height: 40px;
        padding: 16px;
        border: none;
        outline: none;
        border-radius: $default-border-radius;
        cursor: pointer;

        &--secondary {
            background: $white;
            color: var(--primary);
            border: 1px solid var(--primary);
        }

        &:disabled {
            background: #f5f5f5;
            color: #545454 !important;
            cursor: not-allowed;

            i {
                color: #545454 !important;
            }
        }
    }

    &__icon {
        font-size: 20px;
    }

    &__button-box,
    &__button-box.el-button--primary {
        background-color: var(--primary) !important;
        color: $white !important;
        border: none;
        outline: none;

        &:hover {
            background-color: var(--primary) !important;
            color: $white !important;
            border: none;
            outline: none;
        }
    }

    & .field {
        display: block;

        &__label {
            display: inline-block;
            margin-bottom: 3px !important;
            color: $primary;
            font-weight: bold;
        }

        &__input {
            height: 40px;
            width: 100%;
            border-radius: $default-border-radius;
            border: 1px solid $black;
            outline: 0;
            padding: 0 15px;

            &:disabled {
                color: #545454 !important;
                background: #f5f5f5;
                cursor: not-allowed;
            }
        }
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 16px;
    }
}
</style>
